---
title: 'Step 1: Deploy the Collector'
install_track_title: Installation Guide (Crunchy Bridge)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx';
import { MonitoringUserLogRead, MonitoringUserPerDatabaseHelpers } from "../../components/MonitoringUserSetupInstructions";

export const CollectorStartCommand = ({ apiKey, cmd, logExplain }) => {
  return (
    <CodeBlock>
      {`SELECT run_container('` + (cmd ? '' : '-d ') + `-t -e DB_URL="REPLACE_ME" -e PGA_API_KEY="` + (apiKey ? apiKey : 'API_KEY') + '"' + (logExplain ? ' -e PGA_ENABLE_LOG_EXPLAIN=true' : '') + ` -e CRUNCHY_BRIDGE_API_KEY="REPLACE_ME" -e DB_ALL_NAMES=1 --privileged quay.io/pganalyze/collector:stable` + (cmd ? ` ${cmd}` : '') + `');`}
    </CodeBlock>
  );
};


In order to monitor a Crunchy Bridge database you run the pganalyze collector directly on your database server using Postgres Container Apps.

## Grant pg_monitor role and log file access to the application user

We recommend using a role with limited privileges for monitoring. You can use Crunchy Bridge's application user as the user for monitoring, or create a separate role. The instructions here assume you are using the application user.

To ensure the application user can access monitoring statistics for all users (not just itself), and can read the server log, **run the following with superuser credentials**:

<CodeBlock language="sql">
{`GRANT pg_monitor TO application;`}
</CodeBlock>

<MonitoringUserPerDatabaseHelpers username="application" />

In later steps you can now specify the application user credentials as the `DB_URL`.

## Enable Postgres Container Apps

If you have not yet enabled Postgres Container Apps, connect to your Crunchy Bridge Postgres database, and run the following commands as a superuser:

<CodeBlock language="sql">
{`CREATE EXTENSION IF NOT EXISTS pgpodman;`}
</CodeBlock>

## Create Crunchy Bridge API key

Providing the Crunchy Bridge API key to the collector will allow the collector to obtain accurate Storage Space information, as well as cluster information.
It is recommended to create a new API key for the collector and passing it as an environment value.
See the [Crunchy Bridge documentation](https://docs.crunchybridge.com/api-concepts/getting-started) for how to create API keys.

## Run collector test

Run the following command to verify the configuration. For the `DB_URL`, specify the database URL to monitor.
For the `CRUNCHY_BRIDGE_API_KEY`, specify the API key created above.
Before running this command, you can run `\t \a` to show the result in a better format.

<CollectorStartCommand apiKey={props.apiKey} cmd="test" />

This should return output like this:

```
I Running collector test with pganalyze-collector X.XX.X
I [default] Testing statistics collection...
I [default]   Test collection successful for PostgreSQL XX.X
I [default] Submitted full snapshot successfully
I [default] Testing activity snapshots...
I [default] Testing log download...
E [default] ERROR - Could not download logs: could not collect logs: LogReadSql/QueryRow: pq: permission denied for function pg_read_file

...Test summary

Test successful
```

Note that Log Insights will show error until you complete the setup step of [Log Insights](/docs/log-insights/setup/crunchy-bridge/01_create_helper_function_and_test).

## Start collector in the background

With a successful test, you can now start the collector container in the background:

<CollectorStartCommand apiKey={props.apiKey} />

<PublicLastStepLogInsightsLink />
